import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useShortSelector } from 'react-redux-app/lib/modules/core/hooks';

import { SITE_ID__ONLYFEETCASH } from '../../constants/rivcashClones';

import { getRivcashCloneId } from '../../../init/selectors/initData';

import styles from './styles/index.css.json';


const propTypes = {
  children: PropTypes.node.isRequired,
};

const Root = ({ children }) => {
  const siteId = useShortSelector(getRivcashCloneId);

  useEffect(() => {
    if (siteId) {
      document.getElementById('rivcashAppLoader').style.display = 'none';
      document.getElementsByTagName('body')[0].classList.add(siteId === SITE_ID__ONLYFEETCASH
        ? styles.body_onlyfeetcash
        : styles.body_rivcash);
      document.getElementById('rivcashAppRoot').style.display = 'block';
    }
  }, [siteId]);

  return children;
};

Root.propTypes = propTypes;

export default Root;
